import React, { Component } from 'react';
import Icon from '../icon/Icon';
import './button.scss';

export default class Button extends Component {
  constructor() {
    super();
    this.state = {};
  }

  onClick(e) {
    if (!this.props.disabled) {
      this.props.onClick(e);
    }
  }

  render() {
    const {
      type,
      children,
      className,
      icon,
      onClick,
      disabled,
      ...restProps
    } = this.props;

    return (
      <a
        disabled={disabled}
        className={['lf-button', `lf-button--${type}`, disabled ? 'lf-button--disabled' : '', className].join(' ')}
        onClick={e => this.onClick(e)}
        {...restProps}
      >
        {
          icon && <Icon icon={icon} />
        }
        {children}
      </a>
    );
  }
}
